/* ITT FRONT DOOR v4 — NEA chat client, client memory, recall chip,
   suggestions, invitation + guided tour (Oct 30, 2026).
   Loads on every template via layout/theme.liquid:
   - Product pages: records the view into device-local storage, nothing else.
   - Index (front door): mounts the full chat UI rendered by
     snippets/itt-nea-chat.liquid.
   Privacy: the viewed list never leaves this device except as product
   titles/prices attached to the visitor's OWN chat messages (the context
   NEA needs to suggest from what they saw). "Forget me" wipes it.
   Honesty: NEA bubbles contain only real relay replies. When the relay
   reports upstream "stub" (local test mode), the panel shows the stub
   label — stub text is never dressed as NEA. When NEA is unreachable the
   panel says so and offers the tour + viewed-item help instead. */
(function () {
  'use strict';

  var VIEW_KEY = 'itt_fd_viewed_v1';
  var PROXY_KEY = 'itt_nea_proxy';
  var CONV_KEY = 'itt_nea_conv';
  var INVITE_SEEN = 'itt_nea_invite_seen';
  var INVITE_DECLINED = 'itt_nea_invite_declined';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- viewed store (device-local) ---------------- */
  function getViewed() {
    try { var v = JSON.parse(lsGet(VIEW_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function setViewed(v) { lsSet(VIEW_KEY, JSON.stringify(v.slice(0, 8))); }
  function recordView(item) {
    if (!item || !item.handle || !item.title) return;
    var v = getViewed().filter(function (x) { return x.handle !== item.handle; });
    v.unshift({
      handle: item.handle, title: item.title, url: item.url || '',
      price: item.price || '', image: item.image || '', ts: Date.now()
    });
    setViewed(v);
  }

  /* Record this page's product, if the recorder snippet emitted one. */
  var prodEl = document.getElementById('itt-fd-product');
  if (prodEl) {
    try { recordView(JSON.parse(prodEl.textContent)); } catch (e) {}
  }

  var cfg = window.ITTNeaChat;
  var root = document.getElementById('itt-nea-root');
  if (!cfg || !root) return; // non-index templates: recorder only
  var STR = cfg.strings || {};
  /* Shopify's | t filter HTML-escapes apostrophes (&#39;) and the snippet's
     | json then carries the entity as literal text — strings inserted via
     textContent would show "can&#39;t" to visitors. Decode every config
     string once, here. (Strings the snippet renders into HTML markup are
     parsed by the browser and never had the problem.) */
  (function decodeStr() {
    var ta = document.createElement('textarea');
    function dec(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; ta.innerHTML = s; return ta.value; }
    for (var k in STR) STR[k] = dec(STR[k]);
    if (cfg.custom) { cfg.custom.name = dec(cfg.custom.name); cfg.custom.cta = dec(cfg.custom.cta); }
  })();

  /* ---------------- endpoint resolution ---------------- */
  var endpoint = '';
  try {
    var fromUrl = new URLSearchParams(window.location.search).get('nea_proxy');
    if (fromUrl) { endpoint = fromUrl.replace(/\/$/, ''); lsSet(PROXY_KEY, endpoint); }
  } catch (e) {}
  if (!endpoint) endpoint = (lsGet(PROXY_KEY) || cfg.endpoint || '').replace(/\/$/, '');

  /* ---------------- element handles ---------------- */
  function $(s) { return root.querySelector(s); }
  var launcher = $('[data-nea-launcher]');
  var dot = $('[data-nea-dot]');
  var panel = $('[data-nea-panel]');
  var statusEl = $('[data-nea-status]');
  var stubTag = $('[data-nea-stub]');
  var msgsEl = $('[data-nea-msgs]');
  var chipsEl = $('[data-nea-chips]');
  var form = $('[data-nea-form]');
  var input = $('[data-nea-input]');
  var recall = $('[data-nea-recall]');
  var recallMain = $('[data-nea-recall-main]');
  var recallImg = $('[data-nea-recall-img]');
  var recallName = $('[data-nea-recall-name]');
  var recallFan = $('[data-nea-recall-fan]');
  var recallAllBtn = $('[data-nea-recall-all]');
  var recallList = $('[data-nea-recall-list]');
  var invite = $('[data-nea-invite]');
  var tourRoot = $('[data-nea-tour]');
  var tourRing = $('[data-nea-tour-ring]');
  var tourNextLabel = $('[data-nea-tour-next]').textContent;

  var state = {
    open: false,
    online: null, // null = unknown, true = NEA reachable, false = offline mode
    stub: false,
    busy: false,
    welcomed: false,
    lastUserMessage: '',
    tourStep: -1,
    inviteTimer: null
  };

  function setStatus(mode) {
    if (mode === 'online') { statusEl.textContent = STR.statusOnline; dot.className = 'nea-dot nea-dot-on'; }
    else if (mode === 'offline') { statusEl.textContent = STR.statusOffline; dot.className = 'nea-dot nea-dot-off'; }
    else { statusEl.textContent = statusEl.textContent; dot.className = 'nea-dot'; }
  }
  function markStub() {
    if (!state.stub) { state.stub = true; stubTag.hidden = false; }
  }

  /* ---------------- messages ---------------- */
  function addMsg(kind, text) {
    var div = document.createElement('div');
    div.className = 'nea-msg nea-msg-' + kind;
    if (kind === 'nea' || kind === 'user') {
      var who = document.createElement('span');
      who.className = 'nea-msg-who';
      who.textContent = kind === 'nea' ? 'NEA' : (STR.youLabel || 'You');
      div.appendChild(who);
    }
    var body = document.createElement('div');
    body.className = 'nea-msg-body';
    body.innerHTML = esc(text).replace(/\n/g, '<br>');
    div.appendChild(body);
    msgsEl.appendChild(div);
    msgsEl.scrollTop = msgsEl.scrollHeight;
    return div;
  }
  function addThinking() {
    var div = document.createElement('div');
    div.className = 'nea-msg nea-msg-nea nea-thinking';
    div.setAttribute('data-nea-thinking', '');
    div.innerHTML = '<span class="nea-msg-who">NEA</span><div class="nea-msg-body">' +
      '<span class="nea-typing" aria-hidden="true"><i></i><i></i><i></i></span> ' + esc(STR.thinking) + '</div>';
    msgsEl.appendChild(div);
    msgsEl.scrollTop = msgsEl.scrollHeight;
    return div;
  }

  /* ---------------- recall chip ---------------- */
  function renderRecall() {
    var viewed = getViewed();
    var withImg = viewed.filter(function (v) { return v.image; });
    if (!viewed.length || !withImg.length) {
      recall.hidden = true;
      return;
    }
    var top = withImg[0];
    recall.hidden = false;
    recallImg.src = top.image;
    recallImg.alt = top.title;
    recallName.textContent = top.title;
    recallMain.setAttribute('data-url', top.url);
    recallMain.setAttribute('data-handle', top.handle);
    // Fan: up to 3 imaged items including the main one.
    recallFan.innerHTML = '';
    withImg.slice(0, 3).forEach(function (v, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nea-fan-item';
      b.style.setProperty('--fi', i);
      b.setAttribute('aria-label', v.title);
      b.innerHTML = '<img src="' + esc(v.image) + '" alt="" width="56" height="56"><span>' + esc(v.title) + '</span>';
      b.addEventListener('click', function () { window.location.href = v.url; });
      recallFan.appendChild(b);
    });
    recallFan.hidden = true;
    recallMain.setAttribute('aria-expanded', 'false');
    // Flat twin: the full viewed list as plain links.
    recallList.innerHTML = '';
    viewed.forEach(function (v) {
      var a = document.createElement('a');
      a.className = 'nea-recall-row';
      a.href = v.url;
      a.innerHTML = '<span>' + esc(v.title) + '</span>' + (v.price ? '<b>' + esc(v.price) + '</b>' : '');
      recallList.appendChild(a);
    });
    recallList.hidden = true;
    recallAllBtn.setAttribute('aria-expanded', 'false');
    recallAllBtn.hidden = viewed.length <= 1;
  }
  recallMain.addEventListener('click', function () {
    var fanItems = recallFan.querySelectorAll('.nea-fan-item');
    if (fanItems.length > 1 && recallFan.hidden) {
      recallFan.hidden = false;
      recallMain.setAttribute('aria-expanded', 'true');
      return;
    }
    var url = recallMain.getAttribute('data-url');
    if (url) window.location.href = url;
  });
  recallAllBtn.addEventListener('click', function () {
    var show = recallList.hidden;
    recallList.hidden = !show;
    recallAllBtn.setAttribute('aria-expanded', String(show));
  });
  document.addEventListener('click', function (e) {
    if (!recallFan.hidden && !recall.contains(e.target)) {
      recallFan.hidden = true;
      recallMain.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------------- suggestions ---------------- */
  function viewedContext() {
    return getViewed().map(function (v) { return { title: v.title, price: v.price, url: v.url }; });
  }
  function renderChips() {
    chipsEl.innerHTML = '';
    var viewed = getViewed();
    var chips = [];
    function chip(label, fn, opts) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nea-chip';
      b.textContent = label;
      if (opts && opts.disabled) { b.disabled = true; b.title = opts.disabled; }
      else b.addEventListener('click', fn);
      chips.push(b);
    }
    if (viewed.length) {
      var head = document.createElement('span');
      head.className = 'nea-chips-title';
      head.textContent = STR.suggestionsTitle;
      chipsEl.appendChild(head);
      var last = viewed[0];
      chip('↩ ' + last.title, function () { window.location.href = last.url; });
      var creator = document.getElementById('itt-player-creator');
      if (creator) chip(STR.seeInCreator, function () { closePanel(); scrollToEl(creator); });
    }
    chip(STR.sharePicture + ' — ' + cfg.custom.hoodie.price, function () { window.location.href = cfg.custom.hoodie.url; });
    chip(STR.makeYours + ' — ' + cfg.custom.tee.price, function () { window.location.href = cfg.custom.tee.url; });
    chip(STR.askPick, function () { sendMessage(STR.askPickPrompt, true); },
      state.online ? null : { disabled: STR.statusOffline });
    chips.forEach(function (c) { chipsEl.appendChild(c); });
  }

  /* ---------------- panel ---------------- */
  function scrollToEl(el) { if (el) el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); }
  function openPanel() {
    state.open = true;
    panel.hidden = false;
    document.body.classList.add('nea-panel-open');
    launcher.setAttribute('aria-expanded', 'true');
    hideInvite();
    if (!state.welcomed) {
      state.welcomed = true;
      addMsg('sys', STR.welcome);
    }
    renderChips();
    checkHealth();
    setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closePanel() {
    state.open = false;
    panel.hidden = true;
    document.body.classList.remove('nea-panel-open');
    launcher.setAttribute('aria-expanded', 'false');
    try { launcher.focus({ preventScroll: true }); } catch (e) {}
  }
  launcher.addEventListener('click', function () { state.open ? closePanel() : openPanel(); });
  $('[data-nea-close]').addEventListener('click', closePanel);

  function checkHealth() {
    if (!endpoint) { state.online = false; setStatus('offline'); offlineNotice(); return; }
    var ctl = window.AbortController ? new AbortController() : null;
    /* NEA's gateway can take ~12s to answer a health check through its
       proxy (connector note) — a 5s budget would call her offline while
       she is merely slow. 15s is the honest budget. */
    var to = setTimeout(function () { if (ctl) ctl.abort(); }, 15000);
    fetch(endpoint + '/health', { signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        clearTimeout(to);
        if (j && j.upstream === 'stub') markStub();
        state.online = !!(j && j.neaReachable);
        setStatus(state.online ? 'online' : 'offline');
        if (!state.online) offlineNotice();
        renderChips();
      })
      .catch(function () {
        clearTimeout(to);
        state.online = false;
        setStatus('offline');
        offlineNotice();
        renderChips();
      });
  }
  var offlineNoted = false;
  function offlineNotice() {
    if (offlineNoted) return;
    offlineNoted = true;
    var div = addMsg('sys', STR.offlineBody);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nea-btn nea-btn-solid nea-inline-btn';
    b.textContent = STR.tourStart;
    b.addEventListener('click', function () { startTour(); });
    div.appendChild(b);
  }

  /* ---------------- chat send / poll ---------------- */
  function fetchJson(path, payload, timeoutMs) {
    var ctl = window.AbortController ? new AbortController() : null;
    var to = setTimeout(function () { if (ctl) ctl.abort(); }, timeoutMs || 15000);
    return fetch(endpoint + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      clearTimeout(to);
      return r.json().then(function (j) { return { status: r.status, body: j }; });
    }, function (err) { clearTimeout(to); throw err; });
  }

  function sendMessage(text, isPrompt) {
    text = (text || '').trim();
    if (!text || state.busy) return;
    if (!endpoint || state.online === false) {
      if (!isPrompt) addMsg('user', text);
      offlineNotice();
      return;
    }
    state.busy = true;
    state.lastUserMessage = text;
    if (!isPrompt) addMsg('user', text);
    var think = addThinking();
    var started = Date.now();
    var stillTimer = setTimeout(function () {
      var body = think.querySelector('.nea-msg-body');
      if (body) body.innerHTML += '<br><span class="nea-still">' + esc(STR.stillWorking) + '</span>';
    }, 20000);

    function fail() {
      clearTimeout(stillTimer);
      think.remove();
      state.busy = false;
      state.online = false;
      setStatus('offline');
      var div = addMsg('sys', STR.failed);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nea-btn nea-inline-btn';
      b.textContent = STR.retry;
      b.addEventListener('click', function () { state.online = true; sendMessage(state.lastUserMessage, isPrompt); });
      div.appendChild(b);
    }

    fetchJson('/chat', {
      message: text,
      conversation_id: ssGet(CONV_KEY) || undefined,
      context: { viewed: viewedContext() }
    }).then(function (res) {
      if (res.body && res.body.upstream === 'stub') markStub();
      if (res.status !== 202 || !res.body.job_id) { fail(); return; }
      if (res.body.conversation_id) ssSet(CONV_KEY, res.body.conversation_id);
      var jobId = res.body.job_id;
      (function poll() {
        if (Date.now() - started > 240000) { fail(); return; }
        fetchJson('/chat/status', { job_id: jobId }, 15000).then(function (r2) {
          if (r2.body && r2.body.upstream === 'stub') markStub();
          var b = r2.body || {};
          if (b.status === 'completed') {
            clearTimeout(stillTimer);
            think.remove();
            state.busy = false;
            if (b.conversation_id) ssSet(CONV_KEY, b.conversation_id);
            addMsg('nea', b.reply || '');
            renderChips();
          } else if (b.status === 'failed') { fail(); }
          else setTimeout(poll, 2500);
        }, function () { setTimeout(poll, 3000); });
      })();
    }, fail);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value;
    input.value = '';
    sendMessage(text, false);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  });

  /* ---------------- forget me ---------------- */
  $('[data-nea-forget]').addEventListener('click', function () {
    lsDel(VIEW_KEY);
    try { window.sessionStorage.removeItem(CONV_KEY); } catch (e) {}
    renderRecall();
    renderChips();
    addMsg('sys', STR.forgotten);
  });

  /* ---------------- invitation ---------------- */
  function hideInvite() { invite.hidden = true; if (state.inviteTimer) { clearTimeout(state.inviteTimer); state.inviteTimer = null; } }
  function maybeInvite() {
    if (ssGet(INVITE_SEEN) || ssGet(INVITE_DECLINED)) return;
    var viewed = getViewed().length;
    if (!viewed) return;
    var delay = viewed >= 2 ? 5000 : 40000;
    state.inviteTimer = setTimeout(function () {
      if (state.open || ssGet(INVITE_SEEN) || ssGet(INVITE_DECLINED)) return;
      ssSet(INVITE_SEEN, '1');
      invite.hidden = false;
    }, delay);
  }
  $('[data-nea-invite-yes]').addEventListener('click', function () {
    hideInvite();
    openPanel();
    startTour();
  });
  $('[data-nea-invite-no]').addEventListener('click', function () {
    ssSet(INVITE_DECLINED, '1');
    hideInvite();
  });

  /* ---------------- guided tour ---------------- */
  var tourTargets = [
    function () { return document.querySelector('[data-fd-stage]') || document.getElementById('itt-opening'); },
    function () { return document.getElementById('itt-player-creator'); },
    function () { return document.getElementById('wl-updates') || document.querySelector('[id$="__itt_white_home"]'); },
    function () { return null; } // final step: the upload invitation CTA card
  ];
  function tourShow(i) {
    var steps = STR.tourSteps || [];
    if (i < 0 || i >= steps.length) { endTour(); return; }
    state.tourStep = i;
    tourRoot.hidden = false;
    $('[data-nea-tour-stepnum]').textContent = (STR.tourOf || 'Step {a} of {b}').replace('{a}', i + 1).replace('{b}', steps.length);
    $('[data-nea-tour-title]').textContent = steps[i].title;
    $('[data-nea-tour-body]').textContent = steps[i].body;
    $('[data-nea-tour-back]').disabled = i === 0;
    $('[data-nea-tour-next]').textContent = i === steps.length - 1 ? (STR.tourDone || 'Done') : tourNextLabel;
    var cta = $('[data-nea-tour-cta]');
    if (i === steps.length - 1) {
      cta.hidden = false;
      cta.href = cfg.custom.hoodie.url;
      cta.textContent = STR.tourUploadCta + ' — ' + cfg.custom.hoodie.price;
      tourRing.hidden = true;
    } else {
      cta.hidden = true;
      tourRing.hidden = false;
    }
    var target = tourTargets[i]();
    if (target) {
      scrollToEl(target);
      setTimeout(function () { positionRing(target); }, reduced ? 60 : 500);
    } else {
      tourRing.hidden = true;
    }
  }
  function positionRing(el) {
    if (state.tourStep < 0 || !el) return;
    var r = el.getBoundingClientRect();
    tourRing.style.left = Math.max(4, r.left - 6) + 'px';
    tourRing.style.top = Math.max(4, r.top - 6) + 'px';
    tourRing.style.width = Math.min(window.innerWidth - 8, r.width + 12) + 'px';
    tourRing.style.height = (r.height + 12) + 'px';
  }
  function startTour() {
    hideInvite();
    if (state.open) closePanel();
    tourShow(0);
  }
  function endTour() {
    state.tourStep = -1;
    tourRoot.hidden = true;
    openPanel();
  }
  $('[data-nea-tour-btn]').addEventListener('click', startTour);
  $('[data-nea-tour-next]').addEventListener('click', function () { tourShow(state.tourStep + 1); });
  $('[data-nea-tour-back]').addEventListener('click', function () { tourShow(state.tourStep - 1); });
  $('[data-nea-tour-exit]').addEventListener('click', endTour);
  function ringFollow() {
    if (state.tourStep >= 0) { var t = tourTargets[state.tourStep](); if (t) positionRing(t); }
  }
  window.addEventListener('resize', ringFollow);
  window.addEventListener('scroll', ringFollow, { passive: true });

  /* ---------------- global keys ---------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (state.tourStep >= 0) endTour();
    else if (!recallFan.hidden) { recallFan.hidden = true; recallMain.setAttribute('aria-expanded', 'false'); }
    else if (state.open) closePanel();
  });

  /* ---------------- v3 fan coexistence ----------------
     When the hero's hold-fan (a dialog over the stage) is open, the fixed
     chat dock steps aside entirely — at stage-centred scroll positions on
     tablet widths the fan's lower items can otherwise sit on top of the
     recall chip. The fan owns the moment; it has its own close control. */
  var heroFan = document.querySelector('[data-fd-fan]');
  if (heroFan && window.MutationObserver) {
    var syncFan = function () { document.body.classList.toggle('fd-fan-open', !heroFan.hidden); };
    new MutationObserver(syncFan).observe(heroFan, { attributes: true, attributeFilter: ['hidden'] });
    syncFan();
  }

  /* ---------------- boot ---------------- */
  renderRecall();
  maybeInvite();
  setStatus('unknown');
})();
